var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"waiting-open-times"},_vm._l((_vm.items),function({ title }){return _c('li',{key:title},[_c('button',{staticClass:"waiting-open-times__item",attrs:{"title":"Записать на прием","type":"button"},on:{"click":function($event){return _vm.onClick(title)}}},[_vm._v(_vm._s(title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }